import styled from '@emotion/styled';
import Button from '@molecules/Button';

export const StyledPlanCardContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  gap: 16px;
  padding: 16px;

  .text-decoration {
    text-decoration-line: line-through;
  }

  .text-underline {
    text-decoration-line: underline;
    text-align: left;
    white-space: normal;
  }

  .book-button {
    border: 2px solid #32C0A0;
    font-weight: 500;
    font-size: 14px;
  }
`;

export const StyledPlanInfoContainer = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  justify-content: space-between;
`;

export const StyledButton = styled(Button)`
  margin-top: 20px;
`;
